import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconDownload: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 41 41">
    <rect
      x="0.447266"
      y="0.0412598"
      width="40"
      height="40"
      rx="20"
      fill="currentColor"
    />
    <path
      d="M27.4473 30.0413H13.4473V28.0413H27.4473V30.0413ZM20.4473 26.0413L14.4473 20.0413L15.8573 18.6313L19.4473 22.2113V10.0413H21.4473V22.2113L25.0373 18.6313L26.4473 20.0413L20.4473 26.0413Z"
      fill="white"
    />
  </Svg>
)
